import batteryEmptyIcon from "../assets/BatteryEmpty.svg";
import batteryHighIcon from "../assets/BatteryHigh.svg";
import batteryLowIcon from "../assets/BatteryLow.svg";
import batteryMediumIcon from "../assets/BatteryMedium.svg";
import batteryUnavailableIcon from "../assets/BatteryUnavailable.svg";
import searchIcon from "../assets/Search.svg";
import searchOutlineIcon from "../assets/SearchOutline.svg";
import clearIcon from "../assets/Clear.svg";
import memoryEmptyIcon from "../assets/MemoryEmpty.svg";
import memoryHighIcon from "../assets/MemoryHigh.svg";
import memoryLowIcon from "../assets/MemoryLow.svg";
import memoryMediumIcon from "../assets/MemoryMedium.svg";
import memoryUnavailableIcon from "../assets/MemoryUnavailable.svg";

import gatewayActiveIcon from "../assets/GatewayActive.svg";
import gatewayUnavailabelIcon from "../assets/GatewayUnavailable.svg";

import assignedIcon from "../assets/AssignmentAssigned.svg";
import unassignedIcon from "../assets/AssignmentUnassigned.svg";

import syncedFresh from "../assets/SyncedFresh.svg";
import syncedMid from "../assets/SyncedMid.svg";
import syncedOld from "../assets/SyncedOld.svg";
import syncedUnavailable from "../assets/SyncedUnavailable.svg";

import validationSuccess from "../assets/ValidationSuccess.svg";
import validationFailure from "../assets/ValidationFailure.svg";

import activeStatus from "../assets/activeStatus.svg";
import invitedStatus from "../assets/invitedStatus.svg";
import inviteExpiredStatus from "../assets/inviteExpiredStatus.svg";

import { SaveIcon } from "../assets/SaveIcon";
import { CloseOrCancelIcon } from "../assets/CloseOrCancel";

export { searchIcon };
export { clearIcon };
export { searchOutlineIcon };
export { SaveIcon };
export { CloseOrCancelIcon };

export { validationFailure };
export { validationSuccess };

export function getBatteryIcon(value: number | undefined): string {
  if (value === undefined || value === null) {
    return batteryUnavailableIcon;
  } else if (value <= 5) {
    return batteryEmptyIcon;
  } else if (value <= 33) {
    return batteryLowIcon;
  } else if (value <= 66) {
    return batteryMediumIcon;
  } else {
    return batteryHighIcon;
  }
}

export function getMemoryIcon(value: number | undefined): string {
  if (value === undefined || value === null) {
    return memoryUnavailableIcon;
  } else if (value === 0) {
    return memoryEmptyIcon;
  } else if (value <= 33) {
    return memoryLowIcon;
  } else if (value <= 66) {
    return memoryMediumIcon;
  } else {
    return memoryHighIcon;
  }
}

export function getGatewayStatusIcon(value: string | undefined): string {
  if (value === undefined || value === null) {
    return gatewayUnavailabelIcon;
  } else if (value === "active" || value === "connected") {
    return gatewayActiveIcon;
  } else {
    return gatewayUnavailabelIcon;
  }
}

export function getAssignmentIcon(value: string): string {
  if (value !== "3") {
    return assignedIcon;
  } else {
    return unassignedIcon;
  }
}

export function getSyncIcon(value: string | undefined): string {
  switch (value) {
    case "0":
      return syncedFresh;
    case "1":
      return syncedMid;
    case "2":
      return syncedOld;
    default:
      return syncedUnavailable;
  }
}

export function getLoginStatusIcon(value: string | undefined): string {
  switch (value) {
    case "active":
      return activeStatus;
    case "invited":
      return invitedStatus;
    case "invite-expired":
      return inviteExpiredStatus;
    default:
      return syncedUnavailable;
  }
}

export function getSyncStatusID(value: Date | undefined): string {
  if (!value) return "3"; // Return "3" if the value is unavailable.

  const syncDate = value;
  const currentDate = new Date();
  const timeDiffInMs = currentDate.getTime() - syncDate.getTime();
  const timeDiffInDays = timeDiffInMs / (1000 * 60 * 60 * 24); // Convert milliseconds to days

  if (timeDiffInDays <= 1) {
    return "0"; // Freshly synced (within last 24 hours)
  } else if (timeDiffInDays <= 3) {
    return "1"; // Medium sync (1-3 days back)
  } else {
    return "2"; // Old sync (more than 3 days back)
  }
}